import { useEffect } from "react";
import Container from "layouts/container/Container";

function AppRedirect() {
    useEffect(() => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;

        const iosUrl = "https://apps.apple.com/kr/app/puffu/id6504068927";
        const androidUrl = "https://play.google.com/store/apps/details?id=com.worldintl.puffu";
        const appScheme = "puffuios://action";
        const timeout = 1500; // 1.5초

        const redirectToStore = (storeUrl) => {
            alert(`Redirecting to store: ${storeUrl}`);
            window.location.href = storeUrl;
        };

        const tryOpenApp = (schemeUrl, storeUrl) => {
            alert(`Trying to open app with scheme: ${schemeUrl}`);
            const start = Date.now();
            window.location = schemeUrl;

            setTimeout(() => {
                const end = Date.now();
                if (end - start < timeout + 200) {
                    alert('App not installed, redirecting to store.');
                    redirectToStore(storeUrl);
                } else {
                    alert('App opened successfully.');
                }
            }, timeout);
        };

        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            alert('iOS device detected');
            tryOpenApp(appScheme, iosUrl);
        } else if (/android/i.test(userAgent)) {
            alert('Android device detected');
            tryOpenApp(appScheme, androidUrl);
        } else {
            alert('Other device detected, redirecting to website.');
            // redirectToStore("https://yourwebsite.com");
        }
    }, []);

    return (
        <Container>
            앱 있으면 앱 켜고 없으면 설치
        </Container>
    );
}

export default AppRedirect;